var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33971 4.87081L1.93343 3.61558C1.85085 3.36029 1.64937 3.16162 1.39314 3.08329L0.131833 2.69539C-0.0427582 2.64207 -0.044174 2.39574 0.129002 2.33959L1.38465 1.93329C1.63946 1.85071 1.83811 1.64921 1.91692 1.39297L2.30432 0.131604C2.35764 -0.0425243 2.60396 -0.044412 2.66011 0.129244L3.06639 1.38448C3.14897 1.6393 3.35046 1.83796 3.60668 1.91677L4.86799 2.30419C5.04258 2.35799 5.04447 2.60385 4.87082 2.66L3.61517 3.0663C3.36036 3.14888 3.16171 3.35085 3.08291 3.60709L2.6955 4.86798C2.64218 5.04258 2.39586 5.04447 2.33971 4.87081Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1474 13.7158L9.25355 10.9543C9.07188 10.3926 8.6286 9.95557 8.06491 9.78323L5.29003 8.92986C4.90593 8.81255 4.90282 8.27063 5.2838 8.14709L8.04622 7.25323C8.6068 7.07155 9.04385 6.62826 9.21721 6.06454L10.0695 3.28953C10.1868 2.90645 10.7287 2.90229 10.8522 3.28434L11.7461 6.04585C11.9277 6.60646 12.371 7.04352 12.9347 7.2169L15.7096 8.06923C16.0937 8.18758 16.0978 8.72846 15.7158 8.852L12.9534 9.74586C12.3928 9.92754 11.9558 10.3719 11.7824 10.9356L10.9301 13.7096C10.8128 14.0937 10.2709 14.0978 10.1474 13.7158Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.c8b5f5d44e453d576e1b28d0d0b59d6f.svg";
export { ForwardRef as ReactComponent };